<div class="private-policy">
  <div class="contacts">

  <h2>
    Политика конфиденциальности

  </h2>
    <div class="info" [innerHTML]="privatePolicy"></div>
</div>
</div>
